import React from "react";

function ReadytoBuildNFT() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Ready to Build Your NFT Marketplace?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Take the first step toward establishing your own NFT
                  marketplace and becoming a leader in the digital asset
                  revolution. Contact Xeer Technology today for expert NFT
                  marketplace development services and unlock the full potential
                  of your business in the NFT ecosystem.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default ReadytoBuildNFT;
